"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuoteInteractionsStore = void 0;
var mobx_1 = require("mobx");
var QuoteInteractionsStore = (function () {
    function QuoteInteractionsStore() {
        this._quoteInteractions = {};
    }
    QuoteInteractionsStore.prototype.getQuoteFieldInteraction = function (widgetId, fieldId) {
        var _a;
        return (_a = this._quoteInteractions[widgetId]) === null || _a === void 0 ? void 0 : _a.fieldValues[fieldId];
    };
    QuoteInteractionsStore.prototype.setQuoteWidgetInteraction = function (_a, initialValue) {
        var _b;
        var widgetId = _a.widgetId, fieldId = _a.fieldId, value = _a.value;
        var currentInteractions = this._quoteInteractions[widgetId];
        if (!currentInteractions) {
            this._quoteInteractions[widgetId] = {
                fieldValues: (_b = {},
                    _b[fieldId] = value,
                    _b),
            };
            return;
        }
        if (initialValue === value) {
            currentInteractions.fieldValues[fieldId] = undefined;
            if (Object.entries(currentInteractions.fieldValues).filter(function (_a) {
                var _b = __read(_a, 2), _ = _b[0], v = _b[1];
                return v !== undefined;
            }).length === 0) {
                this._quoteInteractions[widgetId] = undefined;
            }
            return;
        }
        currentInteractions.fieldValues[fieldId] = value;
    };
    QuoteInteractionsStore.prototype.serialiseInteractions = function () {
        return Object.fromEntries(Object.entries(this._quoteInteractions).filter(function (entry) { return entry[1] !== undefined; }));
    };
    var _a;
    __decorate([
        mobx_1.observable.deep,
        __metadata("design:type", Object)
    ], QuoteInteractionsStore.prototype, "_quoteInteractions", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, typeof (_a = typeof ValueType !== "undefined" && ValueType) === "function" ? _a : Object]),
        __metadata("design:returntype", void 0)
    ], QuoteInteractionsStore.prototype, "setQuoteWidgetInteraction", null);
    return QuoteInteractionsStore;
}());
exports.QuoteInteractionsStore = QuoteInteractionsStore;
